import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["HomeDiscoveryNavDesktop","HomeDiscoveryNavMobile"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/home/components/HomeDiscoveryNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/DarkModeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/Header/ChangeTeamBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/Header/HeaderBreadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/Header/HeaderClientChildren.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/components/LogoutButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/app/design_system/logomark_ivory.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/app/design_system/wordmark_black.svg");
;
import(/* webpackMode: "eager", webpackExports: ["TimeFromNowText"] */ "/vercel/path0/packages/nextjs/components/TimeFromNowText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/vercel/path0/packages/nextjs/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/components/ui/dropdown-menu.tsx");
